function Inksoft () {
}

Inksoft.funcs = {
    baseUrl: 'https://stores.inksoft.com/marucci_customizer/Api2',

    getDesignIdeaCategories: function(successHandler, errorHandler) {
        var url = this.baseUrl + '/GetDesignCategories?Format=JSON';
        ub.utilities.getJSON(url, successHandler, errorHandler)
    },

    getDesignIdeasByCategory: function(category_id, successHandler, errorHandler) {
        var url = this.baseUrl + '/GetDesignSummaries?DesignCategoryId=' + category_id + '&Format=JSON';
        ub.utilities.getJSON(url, successHandler, errorHandler)
    },

    getDesignDetails: function(designID, successHandler, errorHandler) {
        var url = this.baseUrl + '/GetDesignDetail?designId=' + designID + '&Format=JSON';
        ub.utilities.getJSON(url, successHandler, errorHandler);
    },

    getDesignSummary: function(designID, successHandler, errorHandler) {
        var url = this.baseUrl + '/GetDesignSummary?DesignId='+ designID +'&GetNotes=false&Format=JSON&GetCanvasPlacements=false&GetColors=true&GetRegions=false';
        ub.utilities.getJSON(url, successHandler, errorHandler);
    },

    loadInksoftUploader: function(element, applicationID, designID) {
        var _applicationID = typeof applicationID !== "undefined" ? applicationID : 0;
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");

        if (ub.applicationMascotAsPattern || ub.partMascotAsPattern) {
            next_url = "javascript:designID=0;window.is.isMessageMascotAsPattern(designID," + _applicationID + ");";
        } else {
            next_url = "javascript:designID=0;window.is.isMessage(designID," + _applicationID + ");";
        }

        if (isReversible && onSide2) {
            next_url = "javascript:designID=0;window.isMessagePassThrough(designID," + _applicationID + ");";
        }
        
        var flashvars = {
            DesignerLocation: "https://cdn.inksoft.com/designer/html5",
            EnforceBoundaries: "1",
            Background: "",
            VectorOnly: true,
            DigitalPrint: false,
            ScreenPrint: true,
            Embroidery: false,
            MaxScreenPrintColors: "8",
            RoundPrices: false,
            StoreID: "254194",
            PublisherID: "10697",
            SessionID: "",
            SessionToken: "",
            CartRetailItemID: "",
            UserID: "1036753",
            UserName: "",
            UserEmail: "",
            DesignID: typeof designID !== "undefined" ? designID : "",
            DefaultProductID: "",
            DefaultProductStyleID: "",
            ProductID: "",
            ProductStyleID: "",
            ProductCategoryID: "",
            ClipArtGalleryID: "",
            DisableAddToCart: true,
            DisableUploadImage: false,
            DisableClipArt: true,
            DisableUserArt: true,
            DisableProducts: true,
            DisableDesigns: true,
            DisableDistress: true,
            DisableResolutionMeter: true,
            DisableUploadVectorArt: false,
            DisableUploadRasterArt: false,
            StartPage: "",
            StartPageCategoryID: "",
            StartPageHTML: "",
            StartBanner: "",
            OrderID: "",
            CartID: "",
            ArtID: "",
            FontID: "",
            Domain: "stores.inksoft.com",
            SSLEnabled: true,
            SSLDomain: "stores.inksoft.com",
            StoreURI: "marucci_customizer",
            Admin: "",
            NextURL: next_url,
            CartURL: "https://stores.inksoft.com/marucci_customizer/Cart",
            OrderSummary: true,
            VideoLink: "http://www.youtube.com/watch?v=EfXICdRwt4E",
            Phone: "8007765665",
            WelcomeScreen: "",
            ContactUsLink: "/marucci_customizer/Stores/Contact",
            WelcomeVideo: "",
            GreetBoxSetting: "LANDING",
            HelpVideoOverview: "",
            AutoZoom: true,
            EnableNameNumbers: true,
            AddThisPublisherId: "xa-4fccb0966fef0ba7",
            EnableCartPricing: true,
            EnableCartCheckout: false,
            EnableCartBilling: false,
            EnableCartShipping: true,
            PaymentDisabled: false,
            PaymentRequired: true,
            BillingAddressRequired: true,
            PasswordLength: "4",
            DefaultCountryCode: "PH",
            CurrencyCode: "USD",
            CurrencySymbol: "$",
            HideProductPricing: false,
            PB: true,
            HideClipArtNames: false,
            HideDesignNames: false,
            ThemeName: "flat",
            FullScreen: true,
            Version: "4.60.0.0",
            BackgroundColor: "",
            StoreLogo: "//stores.inksoft.com/images/publishers/10697/stores/marucci_customizer/img/logo.png",
            StoreName: "Marucci Customizer",
            StoreEmail: "jared@prolook.com",
            EnableEZD: false,
            EmbedType: "iframe"
        };

        ub.isMessageIsCalled = true;
        Inksoft.funcs.launchInksoft(flashvars, element);  
    },

    loadInksoftDesigner: function(element, applicationID, designID, callback) {
        var _applicationID = typeof applicationID !== "undefined" ? applicationID : 0;
        var next_url = "";
        var isReversible = _.isEqual(ub.config.isReversible, "1");
        var onSide2 = _.isEqual(ub.config.isEmbedded , "1");

        if (ub.applicationMascotAsPattern || ub.partMascotAsPattern) {
            next_url = "javascript:designID=0;window.is.isMessageMascotAsPattern(designID," + _applicationID + ");";
        } else {
            next_url = "javascript:designID=0;window.is.isMessage(designID," + _applicationID + ");";
        }

        if (isReversible && onSide2) {
            next_url = "javascript:designID=0;window.isMessagePassThrough(designID," + _applicationID + ");";
        }

        var flashvars = {
            DesignerLocation: "https://cdn.inksoft.com/designer/html5",
            EnforceBoundaries: "1",
            Background: "",
            VectorOnly: true,
            DigitalPrint: false,
            ScreenPrint: true,
            Embroidery: false,
            MaxScreenPrintColors: "8",
            RoundPrices: false,
            StoreID: "254194",
            PublisherID: "10697",
            SessionID: "",
            SessionToken: "",
            CartRetailItemID: "",
            UserID: "1036753",
            UserName: "",
            UserEmail: "",
            DesignID: typeof designID !== "undefined" ? designID : "",
            DefaultProductID: "",
            DefaultProductStyleID: "",
            ProductID: "",
            ProductStyleID: "",
            ProductCategoryID: "",
            ClipArtGalleryID: "",
            DisableAddToCart: true,
            DisableUploadImage: false,
            DisableClipArt: true,
            DisableUserArt: true,
            DisableProducts: true,
            DisableDesigns: false,
            DisableDistress: true,
            DisableResolutionMeter: true,
            DisableUploadVectorArt: false,
            DisableUploadRasterArt: false,
            StartPage: "",
            StartPageCategoryID: "",
            StartPageHTML: "",
            StartBanner: "",
            OrderID: "",
            CartID: "",
            ArtID: "",
            FontID: "",
            Domain: "stores.inksoft.com",
            SSLEnabled: true,
            SSLDomain: "stores.inksoft.com",
            StoreURI: "marucci_customizer",
            Admin: "",
            NextURL: next_url,
            CartURL: "https://stores.inksoft.com/marucci_customizer/Cart",
            OrderSummary: true,
            VideoLink: "http://www.youtube.com/watch?v=EfXICdRwt4E",
            Phone: "8007765665",
            WelcomeScreen: "",
            ContactUsLink: "/marucci_customizer/Stores/Contact",
            WelcomeVideo: "",
            GreetBoxSetting: "LANDING",
            HelpVideoOverview: "",
            AutoZoom: true,
            EnableNameNumbers: true,
            AddThisPublisherId: "xa-4fccb0966fef0ba7",
            EnableCartPricing: true,
            EnableCartCheckout: false,
            EnableCartBilling: false,
            EnableCartShipping: true,
            PaymentDisabled: false,
            PaymentRequired: true,
            BillingAddressRequired: true,
            PasswordLength: "4",
            DefaultCountryCode: "PH",
            CurrencyCode: "USD",
            CurrencySymbol: "$",
            HideProductPricing: false,
            PB: true,
            HideClipArtNames: false,
            HideDesignNames: false,
            ThemeName: "flat",
            FullScreen: true,
            Version: "4.60.0.0",
            BackgroundColor: "",
            StoreLogo: "//stores.inksoft.com/images/publishers/10697/stores/marucci_customizer/img/logo.png",
            StoreName: "Marucci Customizer",
            StoreEmail: "jared@prolook.com",
            EnableEZD: false,
            EmbedType: "iframe"
        };

        ub.isMessageIsCalled = true;
        Inksoft.funcs.launchInksoft(flashvars, element);

        if (_.isFunction(callback)) {
            callback();
        }
    },

    launchInksoft: function(flashvars, element) {
        launchDesigner('HTML5DS', flashvars, element);
    },

    createEmbellishmentData: function(data) {
        var self = this;
        var embellishmentData = {
            design_id: data.designSummary.Data.DesignID,
            design_name: data.designSummary.Data.Name,
            user_id: (typeof ub.user.id !== "undefined") ? ub.user.id : 2, 
            created_by_user_id: (typeof ub.user.id !== "undefined") ? ub.user.id : 2, 
            design_summary: JSON.stringify(data.designSummary.Data),
            design_details: JSON.stringify(data.designDetails.Data),
            png_filename: ub.data.inkSoftBaseURL + data.designSummary.Data.Canvases[0].PngRelativeUrl,
            svg_filename: ub.data.inkSoftBaseURL + data.designSummary.Data.Canvases[0].SvgRelativeUrl,
            thumbnail: ub.data.inkSoftBaseURL + data.designSummary.Data.Canvases[0].ThumbnailRelativeUrl,
            type: "User Design",
            category: "User Design",
            is_public: 0,
            status: 'In Development',
            archived: 0
        };

        self.saveEmbellishmentData(embellishmentData, function(res) {
            ub.funcs.updateEmbellishmentList();
        }, function(error) {
            console.log(error);
        });
    },

    saveEmbellishmentData: function(data, successHandler, errorHandler) {
        var _url = ub.endpoints.getFullUrlString('createNewEmbellishmentData');
        // ub.utilities.postJSON(_url, data, successHandler, errorHandler);

        $.ajax({
            url: _url,
            type: "POST", 
            data: JSON.stringify(data),
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {"accessToken": (ub.user !== false) ? atob(ub.user.headerValue) : null},
            success: successHandler,
            error: errorHandler
        });
    },

    closeInksoftModal: function() {
        UIkit.modal("#create-upload-inksoft-modal").hide();
        UIkit.modal("#select-mascot-inksoft-modal").hide();
        UIkit.modal("#inksoft-design-editor-modal").hide();
        UIkit.modal("#inksoft-design-editor-modal-with-conflict").hide();
    }
}

